module.exports = __webpack_public_path__ + "8f21e435b216e57901094a66127daadc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/first_closed.jpg
// module id = 1160
// module chunks = 0